// extracted by mini-css-extract-plugin
export var colorSquare = "_p5-0";
export var danger = "_p5-5";
export var lightPink = "_p5-8";
export var neutralBlue = "_p5-7";
export var neutralYellow = "_p5-6";
export var normal = "_p5-1";
export var primary = "_p5-2";
export var primaryLight = "_p5-3";
export var solidBlack = "_p5-g";
export var solidGreen = "_p5-b";
export var solidLightBlue = "_p5-d";
export var solidNavy = "_p5-c";
export var solidOrange = "_p5-f";
export var solidPink = "_p5-e";
export var solidRed = "_p5-9";
export var solidYellow = "_p5-a";
export var success = "_p5-4";